import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('unset', 'unset'),
    flexDirection: 'column',
    gap: '8px',
  },
  button: {
    padding: '8px',
    background: theme.palette.custom.background.accent,
    borderRadius: theme.borderRadius.md,
    ...dFlex('space-between', 'center'),

    '&:hover': {
      background: '#1C4773B2',
    },

    '&:disabled': {
      opacity: 0.4,
      pointerEvents: 'none',
    },
  },
  row: {
    ...dFlex('unset', 'center'),
    gap: '16px',

    img: {
      borderRadius: '8px',
    },
  },
  badge: {
    borderRadius: theme.borderRadius.sm,
    padding: '8px 16px',
  },
  qrCode: {
    background: theme.palette.custom.tags.success,
  },
  installed: {
    background: theme.palette.custom.tags.processing,
  },
  notInstalled: {
    background: theme.palette.custom.tags.processing,
  },
  icon: {
    borderRadius: theme.borderRadius.md,
  },
}));

export default useStyles;
